import { render, staticRenderFns } from "./EventEntry.vue?vue&type=template&id=037b18a6&scoped=true"
import script from "./EventEntry.vue?vue&type=script&lang=js"
export * from "./EventEntry.vue?vue&type=script&lang=js"
import style0 from "./EventEntry.vue?vue&type=style&index=0&id=037b18a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b18a6",
  null
  
)

export default component.exports